import { JSX } from 'react'

import { IconProps } from '../../icon'

const Mates: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24.5 24H10.9425V9.27454C10.9425 8.86029 11.2783 8.52454 11.6925 8.52454H24.5V24Z'
      fill='#D7D861'
    />
    <path
      d='M24.0165 24H38.5247V9.27454C38.5247 8.86029 38.189 8.52454 37.7747 8.52454H24.0165V24Z'
      fill='#F9D865'
    />
    <path
      d='M24.5 24V39.4755H11.6925C11.2783 39.4755 10.9425 39.1398 10.9425 38.7255V24H24.5Z'
      fill='#AAD3DC'
    />
    <path
      d='M38.4018 40H10.5982C9.44125 40 8.5 39.059 8.5 37.9018V10.0982C8.5 8.94125 9.44125 8 10.5982 8H38.4015C39.5588 8 40.5 8.94125 40.5 10.0982V37.9015C40.5 39.059 39.5588 40 38.4018 40ZM25.0245 38.9508H38.4015C38.9803 38.9508 39.4508 38.48 39.4508 37.9015V24.5245H25.0245V38.9508ZM9.54925 24.5245V37.9015C9.54925 38.48 10.0197 38.9508 10.5985 38.9508H23.9755V24.5245H9.54925ZM25.0245 23.4755H39.4508V10.0982C39.4508 9.5195 38.9803 9.049 38.4015 9.049H25.0245V23.4755ZM9.54925 23.4755H23.9755V9.04925H10.5982C10.0195 9.04925 9.549 9.51975 9.549 10.0985V23.4755H9.54925ZM35.726 35.0103L33.1952 32.4795L30.6645 35.0103L29.9228 34.2685L32.4535 31.7377L29.9228 29.207L30.6645 28.4653L33.1952 30.996L35.726 28.4653L36.4678 29.207L33.937 31.7377L36.4678 34.2685L35.726 35.0103ZM20.864 32.2623H13.1262V31.213H20.864V32.2623ZM17.5197 20.6748H16.4705V17.0887H12.8845V16.0395H16.4705V12.4535H17.5197V16.0395H21.1058V17.0887H17.5197V20.6748ZM36.8272 18.715H28.606V17.6657H36.8272V18.715ZM36.8272 15.9967H28.606V14.9475H36.8272V15.9967Z'
      fill='black'
    />
  </svg>
)

export default Mates
